<template>
  <div class="download2">
    <div class="header-img">
      <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download/banner.png" alt />
    </div>
    <div class="toobar">
      <img align="Baseline" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download2/shouye.png" />&nbsp;&nbsp;&nbsp;1+X证书&nbsp;&nbsp;&nbsp;
      <img
        align="AbsMiddle"
        src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download2/sanjiao.png"
        alt
      />&nbsp;&nbsp;&nbsp;发电集控运行与维护仿真系统
    </div>
    <div class="middle">
      <div class="wenzi" style="margin: 0px auto;width: 1100px;">
        <div
          style="padding-top: 48px;margin-left: -10px;font-family: simhei;font-size: 60px;color: #e8e7e8;"
        >INTRODUCTION</div>
        <div
          style="font-family: simhei;font-size: 28px;color: #4b4b4b;margin-bottom: 48px;">发电集控运行与维护仿真系统简介</div>
        <div style="font-size: 14px;color: #666666;">
          <p><h3>本仿真软件包含五种不同类型机组：</h3><p>
		  <p>（1）面向城市供热、企业自备的中小型热电联产机组，50MW循环流化床母管制机组；</p>
		  <p>（2）面向煤矸石发电的大型循环流化床机组，300MW亚临界CFB机组；</p>
		  <p>（3）面向常规亚临界燃煤机组，330MW亚临界燃煤机组；</p>
		  <p>（4）面向先进的大型循环流化床机组，350MW超临界CFB机组；</p>
		  <p>（5）面向发电企业的主力机组，660MW超超临界燃煤机组。</p>
        </div>
        <div style="margin-top: 50px;">
          <a href="https://bernouly.oss-cn-beijing.aliyuncs.com/simulator/发电集控运行与维护仿真机.7z">
            <img width="420px" src="https://bernouly.oss-cn-beijing.aliyuncs.com/simulator/install-img.png" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style scoped>
.download2 {
  background: #eee;
}

.download2 img {
    display: inline-block;
}

.download2 .header-img {
  width: 100%;
  height: 237px;
}

.download2 .header-img img {
  width: 100%;
  height: 100%;
}

.download2 .middle {
  width: 100%;
  height: 680px;
  background: url(http://bernouly.oss-cn-beijing.aliyuncs.com/images/download2/dibeijing.png) no-repeat;
  background-size: 100% 100%;
}

.download2 .toobar {
  height: 90px;
  width: 1100px;
  margin: 0 auto;
  line-height: 90px;
  color: #929292;
}

.download2 .middle img:hover {
  cursor: pointer;
}

.download2 a {
  color: #fefefe;
  text-decoration: none;
}

.download2 a:hover {
  cursor: pointer;
}

.download2 li {
  width: 100px;
  height: 80px;
  color: #fefefe;
  line-height: 80px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  display: list-item;
}

.download2 li:hover {
  background: #0a57f4;
}
</style>